/**
 * PostMessage protocol constants for the async authentication flow
 * (OAuth popup callbacks and FanFest Auth modal handoff).
 *
 * Shared between `apps/frontend` (sender inside popups/iframes) and
 * `apps/sdk` (receiver on the host page).
 */

/** Envelope `type` field for all async-flow postMessages. */
export const ASYNC_FLOW_MESSAGE_EVENT_NAME =
  "fanfest:async-flow-message" as const;

/** Discriminator values for `data.type` inside an async-flow message. */
export enum AsyncFlowMessageType {
  /** OAuth popup → opener: authentication code + state received. */
  ValidateAuthenticationSuccess = "validate-authentication:success",
  /** OAuth popup → opener: authentication failed. */
  ValidateAuthenticationError = "validate-authentication:error",
  /** Auth modal/iframe → SDK: session JWT ready for validation. */
  AuthModalSuccess = "auth-modal:success",
  /** Auth modal/iframe → SDK: user dismissed the auth modal. */
  AuthModalClosed = "auth-modal:closed",
  /** Opener → popup: close the popup window. */
  CloseWindow = "close-window",
}
